import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Modal, Container, Row, Col } from 'react-bootstrap';
import Button from '../../../../shared/components/Button';
import { useTranslation } from 'react-i18next';
import { get, isEmpty } from 'lodash';
import PrimaryAddress from './PrimaryAddress';
import axios from 'axios';

const AddressModal = (
  {
    formikForm,
    onSaveCallback,
    showAddressUpdateModal,
    loading,
  }
) => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    showAddressUpdate: showAddressUpdateModal,
    countries: []
  });

  useEffect(() => {
    axios.get('/api/v1/countries')
      .then(({ data }) => {
        setState(prev => ({
          ...prev,
          countries: data.countries || []
        }));
      });
  }, []);

  return (
    <Modal show={state.showAddressUpdate} onHide={() => setState({ ...state, showAddressUpdate: false })}>
      <Modal.Header closeButton>
        <Modal.Title>{t('influencers.pages.campaign.addresses.update_shipping_address_modal.header')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('influencers.pages.campaign.addresses.update_shipping_address_modal.save_address_modal_body')}</p>
        <Container className='mt-3'>
          <Row className="no-gutters mb-2">
            <PrimaryAddress
              formik={formikForm}
              countries={state.countries}
              includePhone={true}
              loading={loading}
              colSize={6}
            />
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" type="button" onClick={() => setState({ ...state, showAddressUpdate: false })}>
          {t('common.cancel')}
        </Button>
        <Button variant="primary" type="button" onClick={() => { onSaveCallback() }} disabled={loading || !isEmpty(formikForm.errors)}>
          {t('common.save')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
};

AddressModal.propTypes = {
  formikForm: PropTypes.shape({}).isRequired,
  onSaveCallback: PropTypes.func.isRequired,
  showAddressUpdateModal: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired
};

export default AddressModal;
